import { apiPost } from "./client";

export function postPayment(data) {
  return apiPost("/payments/", data);
}
